var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomepageFineMotorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "NtS_Fine_Motor",
    "data-name": "NtS Fine Motor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48.142,
    height: 48.463,
    viewBox: "0 0 48.142 48.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_846",
    "data-name": "Rectangle 846",
    width: 48.142,
    height: 48.463
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5177",
    "data-name": "Group 5177",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4221",
    "data-name": "Path 4221",
    d: "M35.371,10.65a24.239,24.239,0,0,0-2.247,48.357,6.688,6.688,0,0,0,1.624-1.034,6.441,6.441,0,0,0,1.786-2.5c-.132.018-.267.028-.4.037a3.533,3.533,0,0,1-3.507-1.921,7.109,7.109,0,0,1-.793-2.456c-.058-.407-.1-.813-.136-1.221a4.565,4.565,0,0,0,1.578.954c.243.085.5.149.761.212a3.12,3.12,0,0,1,1.795.87,2.518,2.518,0,0,1,.558,1.851,6.461,6.461,0,0,1-2.745-1.636,5.508,5.508,0,0,0,3.19,2.347,6.711,6.711,0,0,0-.025-3.067.443.443,0,0,0-.212-.278,4.571,4.571,0,0,0-.742-.188,2.51,2.51,0,0,1-1.371-1.249,3.641,3.641,0,0,1-.28-2.105,7.519,7.519,0,0,1,.3-1.268c.044-.139.433-.965.346-1.085a11.565,11.565,0,0,0,1.822,1.66,3.421,3.421,0,0,1,1.085,1.517,2.042,2.042,0,0,1-.09,1.385,1.336,1.336,0,0,1-.386.581c-.218.126-.325-.09-.5-.285a4.925,4.925,0,0,1-1.3-2.671,4.671,4.671,0,0,0,.771,2.463c.166.246.323.5.465.756.079.145.161.291.229.442.02.044.038.088.055.133a5.232,5.232,0,0,1,.174.6,7.191,7.191,0,0,1,.186,1.073c.006.069.012.137.016.206l.008-.022c.074.015.166.029.278.046a4.426,4.426,0,0,0,2.965-.681c.361-.212.695-.468,1.041-.7-.018-.029-.012-.017-.031-.047-.3.155-.588.319-.89.463a5.074,5.074,0,0,1-2.374.605c-.589-.022-.54.065-.6-.558a1.768,1.768,0,0,1,.88-1.882,2.593,2.593,0,0,1,1.774-.261,12.592,12.592,0,0,0,3.4.3l-1.258,1.758a6.359,6.359,0,0,1-1.427,1.729,2.525,2.525,0,0,1-1.712.63A3.035,3.035,0,0,1,37.8,53.69a.65.65,0,0,0-.4-.164c0,.16,0,.32-.012.478a6.9,6.9,0,0,1-.145,1.061,6.7,6.7,0,0,1-1.42,2.9,8.071,8.071,0,0,1-1.363,1.08l-.086.049c.334.014.668.022,1,.022a24.233,24.233,0,0,0,0-48.464",
    transform: "translate(-11.3 -10.65)",
    fill: "#e37225"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5178",
    "data-name": "Group 5178",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4222",
    "data-name": "Path 4222",
    d: "M280.238,472.875a6.77,6.77,0,0,0,.636-.9,6.683,6.683,0,0,0,.474-.973,6.821,6.821,0,0,0,.456-2.089q.014-.238.012-.478a.65.65,0,0,1,.4.164,3.038,3.038,0,0,0,1.638.815,2.522,2.522,0,0,0,1.712-.629A6.373,6.373,0,0,0,287,467.058l1.258-1.759a12.59,12.59,0,0,1-3.4-.3,2.592,2.592,0,0,0-1.774.261,1.768,1.768,0,0,0-.88,1.882c.058.623.008.538.6.559a5.065,5.065,0,0,0,2.374-.605c.3-.143.594-.307.89-.462.018.029.012.017.031.047-.347.236-.68.491-1.041.7a4.42,4.42,0,0,1-2.965.681c-.113-.017-.2-.031-.278-.045l-.009.022c0-.068-.009-.137-.016-.206a7.106,7.106,0,0,0-.186-1.073,5.1,5.1,0,0,0-.174-.6c-.018-.045-.036-.089-.056-.132-.068-.151-.149-.3-.229-.442-.142-.259-.3-.511-.465-.756a4.668,4.668,0,0,1-.771-2.463,4.925,4.925,0,0,0,1.3,2.671c.173.195.28.411.5.286a1.344,1.344,0,0,0,.386-.582,2.04,2.04,0,0,0,.09-1.384,3.423,3.423,0,0,0-1.085-1.518,11.517,11.517,0,0,1-1.821-1.659c.086.119-.3.946-.346,1.084a7.546,7.546,0,0,0-.3,1.268,3.641,3.641,0,0,0,.28,2.105,2.506,2.506,0,0,0,1.37,1.249,4.51,4.51,0,0,1,.742.188.453.453,0,0,1,.135.119.418.418,0,0,1,.076.159,6.71,6.71,0,0,1,.025,3.067,5.508,5.508,0,0,1-3.19-2.347,6.453,6.453,0,0,0,2.745,1.636,2.515,2.515,0,0,0-.558-1.851,3.115,3.115,0,0,0-1.795-.87c-.26-.063-.519-.127-.761-.212a4.6,4.6,0,0,1-1.578-.954c.039.407.078.814.136,1.221a7.1,7.1,0,0,0,.793,2.456,3.533,3.533,0,0,0,3.507,1.921c.134-.008.269-.018.4-.037a6.433,6.433,0,0,1-1.786,2.5,6.733,6.733,0,0,1-1.624,1.034c.411.039.826.066,1.242.083l.086-.049a8.145,8.145,0,0,0,1.363-1.081",
    transform: "translate(-255.722 -425.563)",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5179",
    "data-name": "Group 5179",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4223",
    "data-name": "Path 4223",
    d: "M44.83,448.63s4.233,12.4,19.277,13.767c0,0-12.282-3.043-19.277-13.767",
    transform: "translate(-42.247 -414.894)",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5180",
    "data-name": "Group 5180",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4224",
    "data-name": "Path 4224",
    d: "M345.69,468.794s13.02.319,19.529-13.4c0,0-7.106,10.533-19.529,13.4",
    transform: "translate(-319.933 -421.133)",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5181",
    "data-name": "Group 5181",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4225",
    "data-name": "Path 4225",
    d: "M180.109,52.472c-.649,2.354-2.521,3.887-4.181,3.423s-2.482-2.748-1.833-5.1,2.52-3.888,4.181-3.424,2.481,2.749,1.832,5.1",
    transform: "translate(-161.35 -44.464)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5182",
    "data-name": "Group 5182",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4226",
    "data-name": "Path 4226",
    d: "M119.048,170.956c-2.6-.82-4.233,1.943-3.935,10.241s1.93,9.792,3.193,10.091a51.981,51.981,0,0,0,7.425.524,27.091,27.091,0,0,1,10.47,1.645c4.158,1.719,4.083,3.812,10.916,4.41a56.357,56.357,0,0,1-7.821-5.581c-1.66-1.563-5.434-3.122-9.481-3.687-4.455-.623-7.4-.149-9.6-1.52-1.967-1.224-1.98-7.3-1.089-9.768,0,0,3.147,3.593,5.866,3.14,2.513-.418,4.975-2.168,7.2-7.251,0,0-5.049,4.859-6.979,5.008s-4.827-6.13-4.827-6.13a2.021,2.021,0,0,0-1.337-1.121",
    transform: "translate(-107.084 -158.481)",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5183",
    "data-name": "Group 5183",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4227",
    "data-name": "Path 4227",
    d: "M324.426,172.334a.948.948,0,1,1-.948-.954.951.951,0,0,1,.948.954",
    transform: "translate(-298.557 -158.999)",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5184",
    "data-name": "Group 5184",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4228",
    "data-name": "Path 4228",
    d: "M366.357,283.274a.948.948,0,1,1-.948-.954.951.951,0,0,1,.948.954",
    transform: "translate(-337.257 -261.394)",
    fill: "#fff"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5185",
    "data-name": "Group 5185",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4229",
    "data-name": "Path 4229",
    d: "M354.046,336.644a.948.948,0,1,1-.948-.954.951.951,0,0,1,.948.954",
    transform: "translate(-325.895 -310.653)",
    fill: "#fff"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5186",
    "data-name": "Group 5186",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4230",
    "data-name": "Path 4230",
    d: "M312.116,369.644a.948.948,0,1,1-.948-.954.951.951,0,0,1,.948.954",
    transform: "translate(-287.195 -341.111)",
    fill: "#fff"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5187",
    "data-name": "Group 5187",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4231",
    "data-name": "Path 4231",
    d: "M362,208.874a5.866,5.866,0,0,0,2.785,3.1s.3.11.482.672c.39,1.215-3.11,2.117-4.233,3.7-.186.261-.111.692.631.934.789.259,4.344-1.271,4.344-1.271s0,2.093-1.114,2.579-2.76.793-3.639,1.14c-.788.312-2.079.635-1.448,2.224,0,0,.687,1.065,2.636.187a6.674,6.674,0,0,1,3.156,0c1.819.411,4.27-.71,4.529-1.869s-.854-4.6-.594-5.233.3-2.841-.26-3.326a29.63,29.63,0,0,0-2.933-1.57,8.018,8.018,0,0,1-2.6-2.28c-.481-.987-1.41-.916-1.708-.468a1.57,1.57,0,0,0-.035,1.477",
    transform: "translate(-332.805 -191.952)",
    fill: "#fff"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5188",
    "data-name": "Group 5188",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4232",
    "data-name": "Path 4232",
    d: "M442.323,165.756a2.924,2.924,0,1,1-2.9-3.326,3.133,3.133,0,0,1,2.9,3.326",
    transform: "translate(-403.776 -150.739)",
    fill: "#fff"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5189",
    "data-name": "Group 5189",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4233",
    "data-name": "Path 4233",
    d: "M306.794,265.45a8.6,8.6,0,0,1,.334,5.631,5.051,5.051,0,0,1-2.221,2.275c-.777.224-3,1.774-3.22,2.995s6.625-.2,7.7.548",
    transform: "translate(-279.314 -245.823)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageFineMotorIcon);
export default __webpack_public_path__ + "static/media/homepage_fine_motor_icon.dc296cd8a12468f2d308ee0059dc21e6.svg";
export { ForwardRef as ReactComponent };